import { render } from "./SimpleKeyboard.vue?vue&type=template&id=0a3f85b0&scoped=true"
import script from "./SimpleKeyboard.vue?vue&type=script&lang=js"
export * from "./SimpleKeyboard.vue?vue&type=script&lang=js"

import "./SimpleKeyboard.vue?vue&type=style&index=0&id=0a3f85b0&scoped=true&lang=css"

import exportComponent from "/home/admindb/web/crevent.pedasabis.com/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a3f85b0"]])

export default __exports__